export const saveButtonText = "akDwce";
export default {saveButtonText};